import styled, { css } from "styled-components/native";
import { InnerRibbonProps, Props } from "./models";

export const StyledController = styled.View<Props>`
	display: flex;
	${(props) =>
		props.isTitle &&
		css`
			justify-content: center;
			align-items: center;
			height: 100%;
		`}

	${(props) =>
		props.isShortClips &&
		props.isTitle &&
		css`
			width: 94vw;
		`}

	${(props) =>
		!props.isTitle &&
		css`
			flex-direction: row;
			margin-left: 120px;
		`}

	${(props) =>
		props.isShortClips &&
		css`
			margin-left: 10%;
		`}
`;

export const StyledControllerButton = styled.View`
	display: flex;
`;

export const StyledControllerText = styled.View`
	text-align: center;
	justify-content: center;
	margin-left: 20px;
`;

export const StyledText = styled.Text`
	font-size: 25px;
	color: white;
`;

export const StyledControllerTextContainer = styled.View<Props>`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	${(props) =>
		props.isShortClips &&
		css`
			padding-right: 6.5%;
		`}
`;

export const StyledButtonContainer = styled.View`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 0 1rem;
`;

export const StyledButtonContainerNarrow = styled.View`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 0 0.5rem;
`;

export const StyledControllerContainer = styled.View<Props>`
	display: flex;
	padding: 8px;
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
	flex: 1 0 0;
	align-self: stretch;
	background: transparent;
	${(props) =>
		props.isShortClips &&
		css`
			display: flex;
			width: 18.75rem;
			padding: 0;
			flex-direction: column;
			align-items: flex-start;
			flex-shrink: 0;
			align-self: stretch;
		`}
`;

export const StyledInnerRibbon = styled.View<InnerRibbonProps>`
	display: flex;
	padding: 16px;
	flex-direction: column;
	justify-content: ${(props: InnerRibbonProps) => (props.withButtons ? `space-between` : `center`)};
	align-items: center;
	gap: 24px;
	flex: 1 0 0;
	align-self: stretch;
	border-radius: ${(props: InnerRibbonProps) => (props.isNarrow && props.isShortClips ? `0px` : `12px`)};
	background-color: rgba(10, 29, 57, 0.85);
`;

export const StyledControllerTextNarrow = styled.Text<InnerRibbonProps>`
	display: flex;
	${(props: InnerRibbonProps) =>
		props.withButtons
			? css`
					flex: 1 0 0;
				`
			: css`
					height: 1px;
				`}
	flex-direction: column;
	justify-content: center;
	align-self: stretch;
	color: #f2f2f2;
	text-align: center;
	font-family: Nunito;
	font-size: 1.3125rem;
	font-style: normal;
	font-weight: 400;
	line-height: 25px;
`;

export const StyledTextNarrow = styled.Text`
	color: #f2f2f2;
	font-family: Nunito;
	font-size: 1.3125rem;
	font-style: normal;
	font-weight: 500;
	line-height: 1.5625rem;
`;

export const StyledCloseButton = styled.TouchableOpacity<InnerRibbonProps>`
	position: absolute;
	right: -12px;
	top: calc(50% - 15px);
	background: #0a1d39;
	border-radius: 100%;
	border: 5px;
	border-color: #0a0a0a;
	border-top-color: transparent;
	border-left-color: transparent;
	transform: rotate(-45deg);
	cursor: pointer;
	${(props: InnerRibbonProps) =>
		props.isShortClips &&
		css`
			right: -20px;
		`}
`;
